export default {
  fetched: false,
  list: {},
};
